import { Stack, Typography } from '@mui/material';
import React from 'react';
import { useParams } from 'react-router-dom';

// Components
import ModalComponent from 'src/components/Modal/ModalComponent';
import DataTable from 'src/features/CompanyDetail/Common/DataTable';

// Utilities
import { FORMAT_DATE_TIME } from 'src/utils/constants/config';
import { formatUrlNonProtocol, renderTextOrDefault } from 'src/utils/helpers/stringHelpers';
import { formatUTCTime } from 'src/utils/helpers/dayjs';
import RouterLinkNoUnderline from 'src/components/common/RouterLinkNoUnderline';
import FlagCountry from 'src/components/common/FlagCountry';
import { useQueryAlertDetailPeople } from 'src/services/queries';
import LoadingSkeleton from 'src/components/common/LoadingSkeleton';
import { NATIONALITIES } from 'src/utils/constants/nationality';
import { get } from 'lodash';

interface IProps {
  alert: IAlertPeople | null;
  open: boolean;
  handleClose: () => void;
}

const PopupAlertsDetail: React.FC<IProps> = ({ alert, open, handleClose }) => {
  const { id } = useParams();
  const { data, isFetching } = useQueryAlertDetailPeople({
    peopleId: id || '',
    alertId: alert?.id || '',
  });

  const alertDetail = data?.data;
  const countryCode = get(NATIONALITIES, alertDetail?.country || '', '');

  const listData = [
    {
      key: 'program',
      title: 'Program',
      value: renderTextOrDefault(alertDetail?.program),
    },
    {
      key: 'country',
      title: 'Country',
      value: (
        <Stack spacing={0.5} direction="row">
          <FlagCountry code={countryCode} />
          <Typography variant="body2" color="text.secondary">
            {renderTextOrDefault(alertDetail?.country)}
          </Typography>
        </Stack>
      ),
    },
    {
      key: 'authority',
      title: 'Authority',
      value: renderTextOrDefault(alertDetail?.authority),
    },
    {
      key: 'start_date',
      title: 'Start Date',
      value: formatUTCTime(FORMAT_DATE_TIME.FULL_ONLY_DATE, alertDetail?.start_date || ''),
    },
    {
      key: 'end_date',
      title: 'End Date',
      value: formatUTCTime(FORMAT_DATE_TIME.FULL_ONLY_DATE, alertDetail?.end_date || ''),
    },
    {
      key: 'reason',
      title: 'Reason',
      value: renderTextOrDefault(alertDetail?.reason),
    },
    {
      key: 'summary',
      title: 'Summary',
      value: renderTextOrDefault(alertDetail?.summary),
    },
    {
      key: 'source_link	',
      title: 'Source link',
      value: (
        <RouterLinkNoUnderline
          target="_blank"
          to={formatUrlNonProtocol(alertDetail?.source_link || '')}
          color="secondary"
        >
          {renderTextOrDefault(alertDetail?.source_link)}
        </RouterLinkNoUnderline>
      ),
    },
  ];

  return (
    <ModalComponent padding={4} open={open} handleClose={handleClose} showCloseIcon={true}>
      <Stack direction="column" spacing={4} width="80vw">
        <Typography variant="h4" align="center">
          Sanctions Detail
        </Typography>
        {isFetching ? <LoadingSkeleton count={5} height={50} /> : <DataTable listData={listData} />}
      </Stack>
    </ModalComponent>
  );
};

export default PopupAlertsDetail;
